export const meta = {
    data: {
        title: '',
        code: '',
        originCode: '', // origin Word or other doc
        author: 'Banka CREDITAS a.s.',
        description: '',
        keywords: 'Creditas, PDF',
        subject: '',
        changeLog: '',
        version: '1.0',
    },
    footer: `
<div id="footer" style="color: #888888;">
    Banka CREDITAS a.s., Sokolovská 675/9, Karlín, 186 00 Praha 8<br />
    OR: Městský soud v Praze, oddíl B, vložka 23903, IČO: 63492555, DIČ: CZ63492555<br />
    Volejte zdarma: <a href="tel:+420800888009">800 888 009</a>, e-mail: <a href="mailto:info@creditas.cz">info@creditas.cz</a>, <a href="https://www.creditas.cz" target="_blank">www.creditas.cz</a><br />
</div>
    `,
};
